import Vue from 'vue'
import Router from 'vue-router'
import { store } from '../store/store'
import VueScrollTo from 'vue-scrollto'

import Main from '@/views/Main'
import About from '@/views/About'
import Business from '@/views/Business'
import GlobalNetwork from '@/views/GlobalNetwork'
import Recruit from '@/views/Recruit'
import NotFound from '@/views/NotFound'
// const Main = () => import('@/views/Main')
// const About = () => import('@/views/About')
// const Business = () => import('@/views/Business')
// const GlobalNetwork = () => import('@/views/GlobalNetwork')
// const Recruit = () => import('@/views/Recruit')
// const NotFound = () => import('@/views/NotFound')

Vue.use(Router)

const router = new Router({
    mode: 'history',
    scrollBehavior: function (to, from, savedPosition) {
        let scrollY = window.pageYOffset
        if (to.hash) {
            store.commit('setFromScroll', scrollY)
            setTimeout(function () {
                VueScrollTo.scrollTo(to.hash, 500)
            }, 1200)
            // return { selector: to.hash }
            return { x: 0, y: 0 }
        }
        if (savedPosition) {
            store.commit('setFromScroll', savedPosition)
            return savedPosition
        } else {
            store.commit('setFromScroll', scrollY)
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: '/',
            name: 'Main',
            component: Main
        }, {
            path: '/about',
            name: 'About',
            component: About
        }, {
            path: '/business',
            name: 'Business',
            component: Business
        }, {
            path: '/globalnetwork',
            name: 'GlobalNetwork',
            component: GlobalNetwork
        }, {
            path: '/recruit',
            name: 'Recruit',
            component: Recruit
        }, {
            path: '/404',
            name: 'NotFound',
            component: NotFound
        }, {
            path: '*',
            redirect: '/404'
        }
    ]
})

router.beforeEach((to, from, next) => {
    // if (!from.name) {
    //     next()
    // } else {
    //     if (window.scrollY > 0) {
    //         next()
    //         setTimeout(function () {
    //             window.scrollTo(0, 0)
    //         }, 0)
    //     } else {
    //         next()
    //     }
    // }
    next()
    setTimeout(function () {
        store.commit('setNavOpen', false)
    }, 250)
})
router.afterEach((to, from) => {
    if (to.name === 'Main') {
        setTimeout(function () {
            var visual = document.getElementsByClassName('visual')[0]
            var scrollDown = document.getElementsByClassName('scroll-down')[0]
            visual.style.height = window.innerHeight + 'px'
            scrollDown.style.display = 'block'
        }, 100)
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js